



































import {Component, Vue} from 'vue-property-decorator';
import ProfileForm from '@/components/ProfileForm.vue';
import ResetPasswordForm from '@/components/ResetPasswordForm.vue';
import AuthService from '@/services/AuthService';
import IPasswordForm from '@/types/IPasswordForm';
import {resolveError} from "@/utils/notifications";

@Component({name: 'Profile',
  components: {ResetPasswordForm, ProfileForm}
})
export default class Profile extends Vue {
  async changePassword(data: IPasswordForm) {
    try {
      await AuthService.updatePassword(data)
      await AuthService.refreshToken()
    } catch (e) {
      throw e
    }
  }
}
